import { WorkerListItem } from '@/services/workersV2API';

const NUMERIC_SEARCH_PATTERN = /^[\d\s\-()+]+$/;

const CHECKR_BACKGROUND_LABELS: Record<string, string> = {
  clear: 'Approved',
  engaged: 'Approved',
  'pre-adverse action': 'Declined',
  'post adverse action': 'Declined',
  'report.created': 'Pending',
  'needs review': 'Pending',
};

const BACKGROUND_STATUS_LABELS: Record<string, string> = {
  approved: 'Approved',
  declined: 'Declined',
  requested: 'Pending',
  in_progress: 'Pending',
  needs_review: 'Pending',
  'n/a': 'Pending',
};

const READY_TO_WORK_ONBOARDING_STATUSES = new Set([
  'onboarding_completed',
  'pending_workplace',
]);

export const normalizeWorkerSearch = (search: string): string => {
  const trimmed = search.trim();
  if (!trimmed) return '';

  if (NUMERIC_SEARCH_PATTERN.test(trimmed)) {
    const digitsOnly = trimmed.replace(/\D/g, '');
    if (digitsOnly.length >= 3) return digitsOnly;
  }

  return trimmed;
};

export const getWorkerBackgroundLabel = (
  worker: Pick<WorkerListItem, 'statuses'>,
): string => {
  const checkrStatus = worker.statuses.checkr_status?.toLowerCase();
  if (checkrStatus) {
    return (
      CHECKR_BACKGROUND_LABELS[checkrStatus] || worker.statuses.checkr_status!
    );
  }

  const backgroundStatus = worker.statuses.background_status?.toLowerCase();
  if (!backgroundStatus) return 'N/A';

  return (
    BACKGROUND_STATUS_LABELS[backgroundStatus] ||
    worker.statuses.background_status!
  );
};

export const getDisplayedOnboardingPercentage = (
  worker: Pick<WorkerListItem, 'onboarding_percentage' | 'statuses' | 'dates'>,
): number => {
  if (
    worker.dates.onboarding_completed_at ||
    READY_TO_WORK_ONBOARDING_STATUSES.has(
      worker.statuses.onboarding_status || '',
    )
  ) {
    return 100;
  }

  return Math.max(0, Math.min(worker.onboarding_percentage, 100));
};
